import { KindRegistry } from './kind'
import { taskKind } from './task'
import { projectKind } from './project'
import { settingsKind } from './settings'
import { pageKind } from './page'
import { listKind } from './list'
import { grantKind } from './grant'
import { dayKind } from './day'
import { dateKind } from './date'
import { personKind } from './person'
import { workspaceKind } from './workspace'
import { gitIssueKind, pullRequestKind } from './git'
import { connectorKind } from './connector'
import { agentRunKind } from './agentrun'
import { suggestionKind } from './suggestion'
import { agentSessionKind } from './agentsession'
import { themeProfileKind } from './themeprofile'
import { fileKind } from './file'
import { conceptKind, courseKind, exerciseKind, lessonKind, moduleKind, sessionKind } from './learn'

// Adding a kind: implement ClientKind in src/kinds/<name>/ and register it here.
export const kinds = new KindRegistry()
  .register(taskKind)
  .register(projectKind)
  .register(settingsKind)
  .register(pageKind)
  .register(listKind)
  .register(grantKind)
  .register(dayKind)
  .register(dateKind)
  .register(personKind)
  .register(workspaceKind)
  .register(gitIssueKind)
  .register(pullRequestKind)
  .register(connectorKind)
  .register(agentRunKind)
  .register(suggestionKind)
  .register(agentSessionKind)
  .register(themeProfileKind)
  .register(courseKind)
  .register(moduleKind)
  .register(lessonKind)
  .register(conceptKind)
  .register(sessionKind)
  .register(exerciseKind)
  .register(fileKind)

export {
  taskKind,
  projectKind,
  settingsKind,
  pageKind,
  listKind,
  workspaceKind,
  gitIssueKind,
  pullRequestKind,
  connectorKind,
}
